import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPatientDocumentsByDocumentIdDownloadUrl: build.query<
      GetV2ProviderPatientDocumentsByDocumentIdDownloadUrlApiResponse,
      GetV2ProviderPatientDocumentsByDocumentIdDownloadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patient-documents/${queryArg.documentId}/download-url`,
      }),
    }),
    getV2ProviderPatientDocumentsByPatientIdList: build.query<
      GetV2ProviderPatientDocumentsByPatientIdListApiResponse,
      GetV2ProviderPatientDocumentsByPatientIdListApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patient-documents/${queryArg.pathPatientId}/list`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.organizationId,
          patient_id: queryArg.queryPatientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    postV2ProviderPatientsClinicalInfo: build.mutation<
      PostV2ProviderPatientsClinicalInfoApiResponse,
      PostV2ProviderPatientsClinicalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/clinical-info`,
        method: "POST",
        body: queryArg.patientClinicalInfoRequest,
      }),
    }),
    patchV2ProviderPatientsByPatientId: build.mutation<
      PatchV2ProviderPatientsByPatientIdApiResponse,
      PatchV2ProviderPatientsByPatientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}`,
        method: "PATCH",
        body: queryArg.updatePatientRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdActionsSuggested: build.query<
      GetV2ProviderPatientsByPatientIdActionsSuggestedApiResponse,
      GetV2ProviderPatientsByPatientIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/actions/suggested`,
        params: {
          action_types: queryArg.actionTypes,
        },
      }),
    }),
    getV2ProviderPatientsByPatientIdAllergies: build.query<
      GetV2ProviderPatientsByPatientIdAllergiesApiResponse,
      GetV2ProviderPatientsByPatientIdAllergiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/allergies`,
      }),
    }),
    postV2ProviderPatientsByPatientIdAllergies: build.mutation<
      PostV2ProviderPatientsByPatientIdAllergiesApiResponse,
      PostV2ProviderPatientsByPatientIdAllergiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/allergies`,
        method: "POST",
        body: queryArg.addAllergyRequest,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdAllergiesAndAllergyId: build.mutation<
      DeleteV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiResponse,
      DeleteV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/allergies/${queryArg.allergyId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderPatientsByPatientIdAllergiesAndAllergyId: build.mutation<
      PatchV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiResponse,
      PatchV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/allergies/${queryArg.allergyId}`,
        method: "PATCH",
        body: queryArg.updateAllergyRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdAssessments: build.query<
      GetV2ProviderPatientsByPatientIdAssessmentsApiResponse,
      GetV2ProviderPatientsByPatientIdAssessmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/assessments`,
        params: {
          limit: queryArg.limit,
        },
      }),
    }),
    postV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScores:
      build.mutation<
        PostV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresApiResponse,
        PostV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/assessments/${queryArg.questionnaireId}/scores`,
          method: "POST",
          body: queryArg.addAssessmentScoreRequest,
        }),
      }),
    deleteV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreId:
      build.mutation<
        DeleteV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiResponse,
        DeleteV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/assessments/${queryArg.questionnaireId}/scores/${queryArg.scoreId}`,
          method: "DELETE",
          body: queryArg.deleteAssessmentScoreRequest,
        }),
      }),
    patchV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreId:
      build.mutation<
        PatchV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiResponse,
        PatchV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/assessments/${queryArg.questionnaireId}/scores/${queryArg.scoreId}`,
          method: "PATCH",
          body: queryArg.updateAssessmentScoreRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdClinicalInfo: build.query<
      GetV2ProviderPatientsByPatientIdClinicalInfoApiResponse,
      GetV2ProviderPatientsByPatientIdClinicalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/clinical-info`,
      }),
    }),
    getV2ProviderPatientsByPatientIdCommunicationsPreferences: build.query<
      GetV2ProviderPatientsByPatientIdCommunicationsPreferencesApiResponse,
      GetV2ProviderPatientsByPatientIdCommunicationsPreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/communications-preferences`,
      }),
    }),
    putV2ProviderPatientsByPatientIdCommunicationsPreferencesLanguage:
      build.mutation<
        PutV2ProviderPatientsByPatientIdCommunicationsPreferencesLanguageApiResponse,
        PutV2ProviderPatientsByPatientIdCommunicationsPreferencesLanguageApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/communications-preferences/language`,
          method: "PUT",
          body: queryArg.updateLanguagePreferenceRequest,
        }),
      }),
    putV2ProviderPatientsByPatientIdCommunicationsPreferencesAndPreferenceKey:
      build.mutation<
        PutV2ProviderPatientsByPatientIdCommunicationsPreferencesAndPreferenceKeyApiResponse,
        PutV2ProviderPatientsByPatientIdCommunicationsPreferencesAndPreferenceKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/communications-preferences/${queryArg.preferenceKey}`,
          method: "PUT",
          body: queryArg.updateCommunicationPreferenceRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdDiagnoses: build.query<
      GetV2ProviderPatientsByPatientIdDiagnosesApiResponse,
      GetV2ProviderPatientsByPatientIdDiagnosesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/diagnoses`,
      }),
    }),
    postV2ProviderPatientsByPatientIdDiagnoses: build.mutation<
      PostV2ProviderPatientsByPatientIdDiagnosesApiResponse,
      PostV2ProviderPatientsByPatientIdDiagnosesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/diagnoses`,
        method: "POST",
        body: queryArg.addDiagnosisRequest,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisId: build.mutation<
      DeleteV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiResponse,
      DeleteV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/diagnoses/${queryArg.diagnosisId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisId: build.mutation<
      PatchV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiResponse,
      PatchV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/diagnoses/${queryArg.diagnosisId}`,
        method: "PATCH",
        body: queryArg.updateDiagnosisRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdInfo: build.query<
      GetV2ProviderPatientsByPatientIdInfoApiResponse,
      GetV2ProviderPatientsByPatientIdInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/info`,
      }),
    }),
    getV2ProviderPatientsByPatientIdMedications: build.query<
      GetV2ProviderPatientsByPatientIdMedicationsApiResponse,
      GetV2ProviderPatientsByPatientIdMedicationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/medications`,
      }),
    }),
    postV2ProviderPatientsByPatientIdMedications: build.mutation<
      PostV2ProviderPatientsByPatientIdMedicationsApiResponse,
      PostV2ProviderPatientsByPatientIdMedicationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/medications`,
        method: "POST",
        body: queryArg.addMedicationRequest,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdMedicationsAndMedicationId:
      build.mutation<
        DeleteV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiResponse,
        DeleteV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/medications/${queryArg.medicationId}`,
          method: "DELETE",
        }),
      }),
    patchV2ProviderPatientsByPatientIdMedicationsAndMedicationId:
      build.mutation<
        PatchV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiResponse,
        PatchV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/medications/${queryArg.medicationId}`,
          method: "PATCH",
          body: queryArg.updateMedicationRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdPharmacies: build.query<
      GetV2ProviderPatientsByPatientIdPharmaciesApiResponse,
      GetV2ProviderPatientsByPatientIdPharmaciesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/pharmacies`,
      }),
    }),
    postV2ProviderPatientsByPatientIdPharmacies: build.mutation<
      PostV2ProviderPatientsByPatientIdPharmaciesApiResponse,
      PostV2ProviderPatientsByPatientIdPharmaciesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/pharmacies`,
        method: "POST",
        body: queryArg.addPatientPharmacyRequest,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdPharmaciesAndPharmacyId: build.mutation<
      DeleteV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiResponse,
      DeleteV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/pharmacies/${queryArg.pharmacyId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderPatientsByPatientIdPharmaciesAndPharmacyId: build.mutation<
      PatchV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiResponse,
      PatchV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/pharmacies/${queryArg.pharmacyId}`,
        method: "PATCH",
        body: queryArg.updatePatientPharmacyRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdTreatmentPlan: build.query<
      GetV2ProviderPatientsByPatientIdTreatmentPlanApiResponse,
      GetV2ProviderPatientsByPatientIdTreatmentPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan`,
      }),
    }),
    patchV2ProviderPatientsByPatientIdTreatmentPlan: build.mutation<
      PatchV2ProviderPatientsByPatientIdTreatmentPlanApiResponse,
      PatchV2ProviderPatientsByPatientIdTreatmentPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan`,
        method: "PATCH",
        body: queryArg.updateTreatmentPlanRequest,
      }),
    }),
    postV2ProviderPatientsByPatientIdTreatmentPlan: build.mutation<
      PostV2ProviderPatientsByPatientIdTreatmentPlanApiResponse,
      PostV2ProviderPatientsByPatientIdTreatmentPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan`,
        method: "POST",
        body: queryArg.createTreatmentPlanRequest,
      }),
    }),
    postV2ProviderPatientsByPatientIdTreatmentPlanFromNote: build.mutation<
      PostV2ProviderPatientsByPatientIdTreatmentPlanFromNoteApiResponse,
      PostV2ProviderPatientsByPatientIdTreatmentPlanFromNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan/from-note`,
        method: "POST",
        body: queryArg.saveNoteAsTreatmentPlanRequest,
      }),
    }),
    postV2ProviderPatientsByPatientIdTreatmentPlanMarkReviewed: build.mutation<
      PostV2ProviderPatientsByPatientIdTreatmentPlanMarkReviewedApiResponse,
      PostV2ProviderPatientsByPatientIdTreatmentPlanMarkReviewedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan/mark-reviewed`,
        method: "POST",
      }),
    }),
    postV2ProviderPatientsByPatientIdTreatmentPlanReviewDate: build.mutation<
      PostV2ProviderPatientsByPatientIdTreatmentPlanReviewDateApiResponse,
      PostV2ProviderPatientsByPatientIdTreatmentPlanReviewDateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan/review-date`,
        method: "POST",
        body: queryArg.setTreatmentPlanReviewDateRequest,
      }),
    }),
    postV2ProviderPatientsByPatientIdTreatmentPlanRollback: build.mutation<
      PostV2ProviderPatientsByPatientIdTreatmentPlanRollbackApiResponse,
      PostV2ProviderPatientsByPatientIdTreatmentPlanRollbackApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/treatment-plan/rollback`,
        method: "POST",
        body: queryArg.rollbackTreatmentPlanRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPatientDocumentsByDocumentIdDownloadUrlApiResponse =
  /** status 200 OK */ DocumentDownloadUrlResponse;
export type GetV2ProviderPatientDocumentsByDocumentIdDownloadUrlApiArg = {
  documentId: string;
};
export type GetV2ProviderPatientDocumentsByPatientIdListApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2ProviderPatientDocumentsByPatientIdListApiArg = {
  pathPatientId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by patient ID */
  queryPatientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type PostV2ProviderPatientsClinicalInfoApiResponse =
  /** status 200 OK */ PatientClinicalInfoBatchResponse;
export type PostV2ProviderPatientsClinicalInfoApiArg = {
  patientClinicalInfoRequest: PatientClinicalInfoRequest;
};
export type PatchV2ProviderPatientsByPatientIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type PatchV2ProviderPatientsByPatientIdApiArg = {
  patientId: string;
  updatePatientRequest: UpdatePatientRequest;
};
export type GetV2ProviderPatientsByPatientIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderPatientsByPatientIdActionsSuggestedApiArg = {
  patientId: string;
  /** Comma-separated action types to include, e.g. 'insurance_card_proposal'. Required: an empty filter reads as no results rather than all results. */
  actionTypes: string;
};
export type GetV2ProviderPatientsByPatientIdAllergiesApiResponse =
  /** status 200 OK */ AllergyListResponse;
export type GetV2ProviderPatientsByPatientIdAllergiesApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdAllergiesApiResponse =
  /** status 200 OK */ AllergyResponse;
export type PostV2ProviderPatientsByPatientIdAllergiesApiArg = {
  patientId: string;
  addAllergyRequest: AddAllergyRequest;
};
export type DeleteV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type DeleteV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiArg = {
  patientId: string;
  allergyId: string;
};
export type PatchV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiResponse =
  /** status 200 OK */ AllergyResponse;
export type PatchV2ProviderPatientsByPatientIdAllergiesAndAllergyIdApiArg = {
  patientId: string;
  allergyId: string;
  updateAllergyRequest: UpdateAllergyRequest;
};
export type GetV2ProviderPatientsByPatientIdAssessmentsApiResponse =
  /** status 200 OK */ PatientAssessmentsResponse;
export type GetV2ProviderPatientsByPatientIdAssessmentsApiArg = {
  patientId: string;
  limit?: number;
};
export type PostV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresApiResponse =
  /** status 200 OK */ AssessmentScoreResponse;
export type PostV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresApiArg =
  {
    patientId: string;
    questionnaireId: string;
    addAssessmentScoreRequest: AddAssessmentScoreRequest;
  };
export type DeleteV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiResponse =
  /** status 200 OK */ AssessmentScoreResponse;
export type DeleteV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiArg =
  {
    patientId: string;
    questionnaireId: string;
    scoreId: string;
    deleteAssessmentScoreRequest: DeleteAssessmentScoreRequest;
  };
export type PatchV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiResponse =
  /** status 200 OK */ AssessmentScoreResponse;
export type PatchV2ProviderPatientsByPatientIdAssessmentsAndQuestionnaireIdScoresScoreIdApiArg =
  {
    patientId: string;
    questionnaireId: string;
    scoreId: string;
    updateAssessmentScoreRequest: UpdateAssessmentScoreRequest;
  };
export type GetV2ProviderPatientsByPatientIdClinicalInfoApiResponse =
  /** status 200 OK */ PatientClinicalInfoResponse;
export type GetV2ProviderPatientsByPatientIdClinicalInfoApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdCommunicationsPreferencesApiResponse =
  /** status 200 OK */ CommunicationsPreferencesResponse;
export type GetV2ProviderPatientsByPatientIdCommunicationsPreferencesApiArg = {
  patientId: string;
};
export type PutV2ProviderPatientsByPatientIdCommunicationsPreferencesLanguageApiResponse =
  /** status 200 OK */ CommunicationsPreferencesResponse;
export type PutV2ProviderPatientsByPatientIdCommunicationsPreferencesLanguageApiArg =
  {
    patientId: string;
    updateLanguagePreferenceRequest: UpdateLanguagePreferenceRequest;
  };
export type PutV2ProviderPatientsByPatientIdCommunicationsPreferencesAndPreferenceKeyApiResponse =
  /** status 200 OK */ CommunicationsPreferencesResponse;
export type PutV2ProviderPatientsByPatientIdCommunicationsPreferencesAndPreferenceKeyApiArg =
  {
    patientId: string;
    preferenceKey: string;
    updateCommunicationPreferenceRequest: UpdateCommunicationPreferenceRequest;
  };
export type GetV2ProviderPatientsByPatientIdDiagnosesApiResponse =
  /** status 200 OK */ DiagnosisListResponse;
export type GetV2ProviderPatientsByPatientIdDiagnosesApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdDiagnosesApiResponse =
  /** status 200 OK */ DiagnosisResponse;
export type PostV2ProviderPatientsByPatientIdDiagnosesApiArg = {
  patientId: string;
  addDiagnosisRequest: AddDiagnosisRequest;
};
export type DeleteV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type DeleteV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiArg = {
  patientId: string;
  diagnosisId: string;
};
export type PatchV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiResponse =
  /** status 200 OK */ DiagnosisResponse;
export type PatchV2ProviderPatientsByPatientIdDiagnosesAndDiagnosisIdApiArg = {
  patientId: string;
  diagnosisId: string;
  updateDiagnosisRequest: UpdateDiagnosisRequest;
};
export type GetV2ProviderPatientsByPatientIdInfoApiResponse =
  /** status 200 OK */ PatientInfoResponse;
export type GetV2ProviderPatientsByPatientIdInfoApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdMedicationsApiResponse =
  /** status 200 OK */ MedicationListResponse;
export type GetV2ProviderPatientsByPatientIdMedicationsApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdMedicationsApiResponse =
  /** status 200 OK */ MedicationResponse;
export type PostV2ProviderPatientsByPatientIdMedicationsApiArg = {
  patientId: string;
  addMedicationRequest: AddMedicationRequest;
};
export type DeleteV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type DeleteV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiArg =
  {
    patientId: string;
    medicationId: string;
  };
export type PatchV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiResponse =
  /** status 200 OK */ MedicationResponse;
export type PatchV2ProviderPatientsByPatientIdMedicationsAndMedicationIdApiArg =
  {
    patientId: string;
    medicationId: string;
    updateMedicationRequest: UpdateMedicationRequest;
  };
export type GetV2ProviderPatientsByPatientIdPharmaciesApiResponse =
  /** status 200 OK */ PatientPharmacyListResponse;
export type GetV2ProviderPatientsByPatientIdPharmaciesApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdPharmaciesApiResponse =
  /** status 200 OK */ PatientPharmacyResponse;
export type PostV2ProviderPatientsByPatientIdPharmaciesApiArg = {
  patientId: string;
  addPatientPharmacyRequest: AddPatientPharmacyRequest;
};
export type DeleteV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type DeleteV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiArg = {
  patientId: string;
  pharmacyId: string;
};
export type PatchV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiResponse =
  /** status 200 OK */ PatientPharmacyResponse;
export type PatchV2ProviderPatientsByPatientIdPharmaciesAndPharmacyIdApiArg = {
  patientId: string;
  pharmacyId: string;
  updatePatientPharmacyRequest: UpdatePatientPharmacyRequest;
};
export type GetV2ProviderPatientsByPatientIdTreatmentPlanApiResponse =
  /** status 200 OK */ TreatmentPlanResponse;
export type GetV2ProviderPatientsByPatientIdTreatmentPlanApiArg = {
  patientId: string;
};
export type PatchV2ProviderPatientsByPatientIdTreatmentPlanApiResponse =
  /** status 200 OK */ TreatmentPlanResponse;
export type PatchV2ProviderPatientsByPatientIdTreatmentPlanApiArg = {
  patientId: string;
  updateTreatmentPlanRequest: UpdateTreatmentPlanRequest;
};
export type PostV2ProviderPatientsByPatientIdTreatmentPlanApiResponse =
  /** status 200 OK */ TreatmentPlanResponse;
export type PostV2ProviderPatientsByPatientIdTreatmentPlanApiArg = {
  patientId: string;
  createTreatmentPlanRequest: CreateTreatmentPlanRequest;
};
export type PostV2ProviderPatientsByPatientIdTreatmentPlanFromNoteApiResponse =
  /** status 200 OK */ TreatmentPlanResponse;
export type PostV2ProviderPatientsByPatientIdTreatmentPlanFromNoteApiArg = {
  patientId: string;
  saveNoteAsTreatmentPlanRequest: SaveNoteAsTreatmentPlanRequest;
};
export type PostV2ProviderPatientsByPatientIdTreatmentPlanMarkReviewedApiResponse =
  /** status 200 OK */ MarkTreatmentPlanReviewedResponse;
export type PostV2ProviderPatientsByPatientIdTreatmentPlanMarkReviewedApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdTreatmentPlanReviewDateApiResponse =
  /** status 200 OK */ TreatmentPlanReviewDateResponse;
export type PostV2ProviderPatientsByPatientIdTreatmentPlanReviewDateApiArg = {
  patientId: string;
  setTreatmentPlanReviewDateRequest: SetTreatmentPlanReviewDateRequest;
};
export type PostV2ProviderPatientsByPatientIdTreatmentPlanRollbackApiResponse =
  /** status 200 OK */ TreatmentPlanResponse;
export type PostV2ProviderPatientsByPatientIdTreatmentPlanRollbackApiArg = {
  patientId: string;
  rollbackTreatmentPlanRequest: RollbackTreatmentPlanRequest;
};
export type DocumentDownloadUrlResponse = {
  /** Presigned S3 URL for downloading the document */
  download_url: string;
  /** URL expiration time in seconds */
  expires_in: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type CommunicationChannelStatus = {
  /** Communication channel: 'sms' or 'email' */
  channel: string;
  /** When message was delivered */
  delivered_at?: string | null;
  /** Error details if delivery failed */
  error_message?: string | null;
  /** When delivery failed */
  failed_at?: string | null;
  /** When message was sent */
  sent_at?: string | null;
  /** Delivery status: queued, sent, delivered, failed, bounced, dropped, opened, clicked */
  status: string;
};
export type FormStatusInfo = {
  /** ID of the form session */
  form_session_id: string;
  /** Form status: pending, in_progress, or completed */
  status: string;
  /** When the form was submitted */
  submitted_at?: string | null;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type DocumentSummaryResponse = {
  author_facility?: string | null;
  author_provider_name?: string | null;
  authored_at?: string | null;
  /** Per-channel delivery status if document was sent to patient */
  communication_status?: CommunicationChannelStatus[] | null;
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  /** Unique identifier for the document */
  document_id: string;
  /** User-set title for the document (legacy DocumentMetadata). For DocRef-backed rows, `title` carries the extraction-derived clinical title. */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'form', 'document') */
  document_type?: string | null;
  effective_date?: string | null;
  encounter_id?: string | null;
  /** Original filename */
  filename: string;
  /** Form lifecycle status if document originated from a form submission */
  form_status?: FormStatusInfo | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  processing_status?: string | null;
  signed_at?: string | null;
  /** File size in bytes */
  size_bytes: number;
  /** Which storage layer backs this row. 'document_metadata' = legacy mongo (thin). 'document_reference' = GDN-914 DocRef with Fast Card enrichment. FE switches download / detail flows on this. */
  source?: string;
  source_artifact_id?: string | null;
  source_location?: {
    [key: string]: any;
  } | null;
  tags?: string[];
  title?: string | null;
};
export type DocumentListResponse = {
  items: DocumentSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type DiagnosisStatus = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** When the diagnosis was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the diagnosis was added to the chart. */
  date_added?: string | null;
  /** Diagnosis ID (UUID). */
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  /** Human-readable diagnosis name. */
  name: string;
  /** Suggestion-workflow status: 'accepted' (confirmed on the chart), 'suggested' (AI-proposed, pending provider review), or 'rejected'. Distinct from clinical active/inactive — see is_active. */
  status: DiagnosisStatus;
};
export type LastSession = {
  /** Date of the last session */
  date_completed?: string | null;
  /** Summary of the last session */
  summary?: string | null;
};
export type MedicationStatus =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo = {
  /** When the medication was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the medication was prescribed. */
  date_prescribed?: string | null;
  /** Prescribed dose (e.g. '1 tablet'). */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  /** How often to take (e.g. 'twice daily'). */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  /** Medication ID (UUID). */
  medication_id: string;
  /** Human-readable medication name. */
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Suggestion-workflow status: 'accepted', 'suggested' (AI-proposed, pending review), 'rejected', or 'discontinued'. Distinct from clinical active/inactive — see is_active. */
  status: MedicationStatus;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PatientPharmacyInfo = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this pharmacy has a DoseSpot PharmacyId. This is an identity link, not a sync health indicator; prefer sync_status for health. */
  is_dosespot_linked?: boolean;
  is_primary?: boolean;
  name: string;
  patient_pharmacy_id: string;
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  sync_failure_reason?: string | null;
  /** Current DoseSpot sync health. This takes precedence over is_dosespot_linked when sync_status is sync_failed. */
  sync_status?: "dosespot_linked" | "local_only" | "sync_failed";
  zip?: string | null;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type ScoreEntry = {
  /** When this score was recorded. */
  date?: string | null;
  /** Severity band for this score (e.g. 'moderate'). */
  interpretation?: string | null;
  /** Numeric score for this completion. */
  score: number;
};
export type ScoreTrend = "up" | "down" | "stable";
export type QuestionnaireInfo = {
  /** Date of most recent completion */
  date_completed?: string | null;
  /** Name of the questionnaire (e.g., PHQ-9, GAD-7) */
  name: string;
  /** Previous score for comparison */
  previous_score?: number | null;
  /** Questionnaire ID (UUID). */
  questionnaire_id: string;
  /** Most recent score */
  score?: number | null;
  /** Full score history, chronological order */
  scores?: ScoreEntry[];
  /** Score trend direction */
  trend?: ScoreTrend | null;
};
export type PatientClinicalInfo = {
  diagnoses?: DiagnosisInfo[];
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  gender?: string | null;
  has_pending_diagnosis_suggestions?: boolean;
  has_pending_medication_suggestions?: boolean;
  last_name?: string | null;
  last_session?: LastSession | null;
  medications?: MedicationInfo[];
  middle_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
  pharmacies?: PatientPharmacyInfo[];
  preferred_name?: string | null;
  primary_address?: PatientAddress | null;
  primary_pharmacy?: PatientPharmacyInfo | null;
  pronouns?: string | null;
  questionnaires?: QuestionnaireInfo[];
};
export type PatientClinicalInfoBatchResponse = {
  /** List of patient details */
  patients: PatientClinicalInfo[];
  /** Number of patients found and accessible */
  total_found: number;
  /** Total number of patient IDs requested */
  total_requested: number;
};
export type PatientClinicalInfoRequest = {
  /** List of patient IDs to fetch details for */
  patient_ids: string[];
};
export type SuccessResponse = {
  /** Whether the operation succeeded */
  success?: boolean;
};
export type PatientAddressPatch = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  phone?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type PatientAddressesPatch = {
  primary_address?: PatientAddressPatch | null;
  secondary_address?: PatientAddressPatch | null;
};
export type ContactMethodPreference = "preferred" | "avoid" | "neutral";
export type CommunicationPreferencesWrite = {
  email?: ContactMethodPreference | null;
  phone_call?: ContactMethodPreference | null;
  sms?: ContactMethodPreference | null;
};
export type PatientContactPatch = {
  communication_preferences?: CommunicationPreferencesWrite | null;
  email?: string | null;
  mobile_phone?: string | null;
  /** Preferred language ISO 639-1 code (e.g. 'en', 'es') */
  preferred_language?: string | null;
};
export type PatientDemographicsPatch = {
  dob?: string | null;
  first_name?: string | null;
  gender?: string | null;
  /** Height in inches (in) */
  height?: number | null;
  /** MRN / PRN */
  identifier?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  preferred_name?: string | null;
  pronouns?: string | null;
  race?: string | null;
  /** Sex for claims (Male/Female) */
  sex?: string | null;
  /** Weight in pounds (lb) */
  weight?: number | null;
};
export type PatientEmergencyContactPatch = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  relationship?: string | null;
};
export type PatientEmploymentPatch = {
  employment_status?: string | null;
  occupation?: string | null;
  patient_consent_on_file?: boolean | null;
};
export type CoverageWriteItem = {
  consent_on_file?: boolean | null;
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary. Defaults to 1 on create if omitted. */
  coverage_order?: number | null;
  /** If true, soft-delete this coverage instead of updating it. */
  delete?: boolean;
  /** Coverage start date */
  effective_date?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Coverage UUID. Present for update/delete, absent for create. */
  patient_insurance_coverage_id?: string | null;
  /** External payer identifier */
  payer_id?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  /** Plan name */
  plan_name?: string | null;
  /** self, spouse, child, other */
  relationship_to_subscriber?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
};
export type UpdatePatientRequest = {
  addresses?: PatientAddressesPatch | null;
  /** Communication method preferences (phone_call, sms, email) */
  communication_preferences?: CommunicationPreferencesWrite | null;
  contact?: PatientContactPatch | null;
  /** Stripe payment method ID to set as the default. */
  default_payment_method_id?: string | null;
  demographics?: PatientDemographicsPatch | null;
  dob?: string | null;
  email?: string | null;
  emergency_contact?: PatientEmergencyContactPatch | null;
  employment?: PatientEmploymentPatch | null;
  employment_status?: string | null;
  first_name?: string | null;
  gender?: string | null;
  /** Height in inches (in) */
  height?: number | null;
  /** MRN / PRN */
  identifier?: string | null;
  /** Array of coverage operations. Include id to update/delete, omit to create. */
  insurance_coverages?: CoverageWriteItem[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  mobile_phone?: string | null;
  occupation?: string | null;
  patient_consent_on_file?: boolean | null;
  /** Preferred language ISO 639-1 code (e.g. 'en', 'es') */
  preferred_language?: string | null;
  preferred_name?: string | null;
  primary_address?: PatientAddressPatch | null;
  pronouns?: string | null;
  race?: string | null;
  /** Stripe payment method IDs to detach from this patient. */
  remove_payment_method_ids?: string[] | null;
  secondary_address?: PatientAddressPatch | null;
  /** Sex for claims (Male/Female) */
  sex?: string | null;
  /** Weight in pounds (lb) */
  weight?: number | null;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type ActionResponse = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo2 | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ActionListResponse = {
  items: ActionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AllergyStatus = "accepted" | "suggested";
export type AllergyInfo = {
  allergen: string;
  /** How the allergen is represented, including the explicit no-known-allergies sentinel. */
  allergen_type: "coded" | "freetext" | "nka";
  allergy_id: string;
  date_added?: string | null;
  /** Whether the allergy is currently active */
  is_active?: boolean;
  /** ISO 8601 date when allergy was first identified */
  onset_date?: string | null;
  reaction?: string | null;
  severity?: ("mild" | "moderate" | "severe" | "life-threatening") | null;
  status?: AllergyStatus;
};
export type AllergyListResponse = {
  allergies: AllergyInfo[];
};
export type AllergyStatus2 = "accepted" | "suggested";
export type AllergyInfo2 = {
  allergen: string;
  /** How the allergen is represented, including the explicit no-known-allergies sentinel. */
  allergen_type: "coded" | "freetext" | "nka";
  allergy_id: string;
  date_added?: string | null;
  /** Whether the allergy is currently active */
  is_active?: boolean;
  /** ISO 8601 date when allergy was first identified */
  onset_date?: string | null;
  reaction?: string | null;
  severity?: ("mild" | "moderate" | "severe" | "life-threatening") | null;
  status?: AllergyStatus2;
};
export type AllergyResponse = {
  allergy: AllergyInfo2;
};
export type AddAllergyRequest = {
  /** Name of the allergen */
  allergen: string;
  /** ISO 8601 date when allergy was recorded (defaults to now) */
  date_added?: string | null;
  /** Whether the allergy is currently active */
  is_active?: boolean | null;
  /** ISO 8601 date when allergy was first identified */
  onset_date?: string | null;
  /** Type of reaction */
  reaction?: string | null;
  severity?: ("mild" | "moderate" | "severe" | "life-threatening") | null;
};
export type UpdateAllergyRequest = {
  /** Name of the allergen */
  allergen?: string | null;
  /** ISO 8601 date when allergy was recorded */
  date_added?: string | null;
  /** Whether the allergy is currently active */
  is_active?: boolean | null;
  /** ISO 8601 date when allergy was first identified */
  onset_date?: string | null;
  /** Type of reaction */
  reaction?: string | null;
  severity?: ("mild" | "moderate" | "severe" | "life-threatening") | null;
};
export type PatientAssessmentCapabilities = {
  can_add_manual_score: boolean;
  can_delete_score: boolean;
  can_edit_score: boolean;
  can_send: boolean;
};
export type AssessmentScore = {
  completed_at: string;
  editable: boolean;
  form_session_id?: string | null;
  interpretation?: string | null;
  score: number;
  score_id: string;
  source: "form_submission" | "manual" | "legacy_import";
};
export type AssessmentSeverityBand = {
  interpretation: string;
  max: number;
  min: number;
  severity?: string | null;
};
export type AssessmentInstrument = {
  clinically_meaningful_change?: boolean | null;
  display_name: string;
  form_id?: string | null;
  instrument_key: string;
  latest?: AssessmentScore | null;
  lower_is_better?: boolean | null;
  max_score?: number | null;
  min_score?: number | null;
  previous?: AssessmentScore | null;
  questionnaire_id: string;
  scores?: AssessmentScore[];
  severity_bands?: AssessmentSeverityBand[];
  total_scores: number;
  trend: "improving" | "worsening" | "stable" | "unknown";
};
export type PatientAssessmentsResponse = {
  capabilities: PatientAssessmentCapabilities;
  instruments: AssessmentInstrument[];
};
export type AssessmentScore2 = {
  completed_at: string;
  editable: boolean;
  form_session_id?: string | null;
  interpretation?: string | null;
  score: number;
  score_id: string;
  source: "form_submission" | "manual" | "legacy_import";
};
export type AssessmentScoreResponse = {
  score: AssessmentScore2;
};
export type AddAssessmentScoreRequest = {
  completed_at: string;
  score: number;
};
export type DeleteAssessmentScoreRequest = {
  confirm_form_sourced?: boolean;
};
export type UpdateAssessmentScoreRequest = {
  completed_at?: string | null;
  confirm_form_sourced?: boolean;
  score?: number | null;
};
export type DiagnosisStatus2 = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo2 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** When the diagnosis was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the diagnosis was added to the chart. */
  date_added?: string | null;
  /** Diagnosis ID (UUID). */
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  /** Human-readable diagnosis name. */
  name: string;
  /** Suggestion-workflow status: 'accepted' (confirmed on the chart), 'suggested' (AI-proposed, pending provider review), or 'rejected'. Distinct from clinical active/inactive — see is_active. */
  status: DiagnosisStatus2;
};
export type LastSession2 = {
  /** Date of the last session */
  date_completed?: string | null;
  /** Summary of the last session */
  summary?: string | null;
};
export type MedicationStatus2 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo2 = {
  /** When the medication was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the medication was prescribed. */
  date_prescribed?: string | null;
  /** Prescribed dose (e.g. '1 tablet'). */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  /** How often to take (e.g. 'twice daily'). */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  /** Medication ID (UUID). */
  medication_id: string;
  /** Human-readable medication name. */
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Suggestion-workflow status: 'accepted', 'suggested' (AI-proposed, pending review), 'rejected', or 'discontinued'. Distinct from clinical active/inactive — see is_active. */
  status: MedicationStatus2;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PatientPharmacyInfo2 = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this pharmacy has a DoseSpot PharmacyId. This is an identity link, not a sync health indicator; prefer sync_status for health. */
  is_dosespot_linked?: boolean;
  is_primary?: boolean;
  name: string;
  patient_pharmacy_id: string;
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  sync_failure_reason?: string | null;
  /** Current DoseSpot sync health. This takes precedence over is_dosespot_linked when sync_status is sync_failed. */
  sync_status?: "dosespot_linked" | "local_only" | "sync_failed";
  zip?: string | null;
};
export type PatientAddress2 = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type ScoreEntry2 = {
  /** When this score was recorded. */
  date?: string | null;
  /** Severity band for this score (e.g. 'moderate'). */
  interpretation?: string | null;
  /** Numeric score for this completion. */
  score: number;
};
export type ScoreTrend2 = "up" | "down" | "stable";
export type QuestionnaireInfo2 = {
  /** Date of most recent completion */
  date_completed?: string | null;
  /** Name of the questionnaire (e.g., PHQ-9, GAD-7) */
  name: string;
  /** Previous score for comparison */
  previous_score?: number | null;
  /** Questionnaire ID (UUID). */
  questionnaire_id: string;
  /** Most recent score */
  score?: number | null;
  /** Full score history, chronological order */
  scores?: ScoreEntry2[];
  /** Score trend direction */
  trend?: ScoreTrend2 | null;
};
export type PatientClinicalInfo2 = {
  diagnoses?: DiagnosisInfo2[];
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  gender?: string | null;
  has_pending_diagnosis_suggestions?: boolean;
  has_pending_medication_suggestions?: boolean;
  last_name?: string | null;
  last_session?: LastSession2 | null;
  medications?: MedicationInfo2[];
  middle_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
  pharmacies?: PatientPharmacyInfo2[];
  preferred_name?: string | null;
  primary_address?: PatientAddress2 | null;
  primary_pharmacy?: PatientPharmacyInfo2 | null;
  pronouns?: string | null;
  questionnaires?: QuestionnaireInfo2[];
};
export type PatientClinicalInfoResponse = {
  /** Patient clinical info */
  patient_clinical_info: PatientClinicalInfo2;
};
export type ContactMethodPreference2 = "preferred" | "avoid" | "neutral";
export type CommunicationsPreferencesResponse = {
  /** Email preference */
  email?: ContactMethodPreference2;
  /** Phone call preference */
  phone_call?: ContactMethodPreference2;
  /** Preferred language (ISO 639-1 code, e.g., 'en', 'es', 'fr') */
  preferred_language?: string;
  /** SMS/text message preference */
  sms?: ContactMethodPreference2;
};
export type UpdateLanguagePreferenceRequest = {
  /** Preferred language (ISO 639-1 code, e.g., 'en', 'es', 'fr') */
  preferred_language: string;
};
export type ContactMethodPreference3 = "preferred" | "avoid" | "neutral";
export type UpdateCommunicationPreferenceRequest = {
  /** Preference value: 'preferred', 'avoid', or 'neutral' */
  preference_value: ContactMethodPreference3;
};
export type DiagnosisStatus3 = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo3 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** When the diagnosis was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the diagnosis was added to the chart. */
  date_added?: string | null;
  /** Diagnosis ID (UUID). */
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  /** Human-readable diagnosis name. */
  name: string;
  /** Suggestion-workflow status: 'accepted' (confirmed on the chart), 'suggested' (AI-proposed, pending provider review), or 'rejected'. Distinct from clinical active/inactive — see is_active. */
  status: DiagnosisStatus3;
};
export type DiagnosisListResponse = {
  diagnoses: DiagnosisInfo3[];
};
export type DiagnosisStatus4 = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo4 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** When the diagnosis was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the diagnosis was added to the chart. */
  date_added?: string | null;
  /** Diagnosis ID (UUID). */
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  /** Human-readable diagnosis name. */
  name: string;
  /** Suggestion-workflow status: 'accepted' (confirmed on the chart), 'suggested' (AI-proposed, pending provider review), or 'rejected'. Distinct from clinical active/inactive — see is_active. */
  status: DiagnosisStatus4;
};
export type DiagnosisResponse = {
  diagnosis: DiagnosisInfo4;
};
export type DiagnosisStatus5 = "accepted" | "suggested" | "rejected";
export type AddDiagnosisRequest = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** ISO 8601 date when diagnosis was added (defaults to now) */
  date_added?: string | null;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  is_active?: boolean | null;
  /** Diagnosis name */
  name: string;
  /** Status of the diagnosis (defaults to accepted) */
  status?: DiagnosisStatus5 | null;
};
export type DiagnosisStatus6 = "accepted" | "suggested" | "rejected";
export type UpdateDiagnosisRequest = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** ISO 8601 date when diagnosis was added */
  date_added?: string | null;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  is_active?: boolean | null;
  /** Diagnosis name */
  name?: string | null;
  /** Status of the diagnosis */
  status?: DiagnosisStatus6 | null;
};
export type PatientAddressSchema = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type AddressesSection = {
  primary_address?: PatientAddressSchema | null;
  secondary_address?: PatientAddressSchema | null;
};
export type AllergyStatus3 = "accepted" | "suggested";
export type AllergyInfo3 = {
  allergen: string;
  /** How the allergen is represented, including the explicit no-known-allergies sentinel. */
  allergen_type: "coded" | "freetext" | "nka";
  allergy_id: string;
  date_added?: string | null;
  /** Whether the allergy is currently active */
  is_active?: boolean;
  /** ISO 8601 date when allergy was first identified */
  onset_date?: string | null;
  reaction?: string | null;
  severity?: ("mild" | "moderate" | "severe" | "life-threatening") | null;
  status?: AllergyStatus3;
};
export type ConsentSection = {
  patient_consent_on_file?: boolean | null;
};
export type ContactMethodPreference4 = "preferred" | "avoid" | "neutral";
export type CommunicationsPreferencesResponse2 = {
  /** Email preference */
  email?: ContactMethodPreference4;
  /** Phone call preference */
  phone_call?: ContactMethodPreference4;
  /** Preferred language (ISO 639-1 code, e.g., 'en', 'es', 'fr') */
  preferred_language?: string;
  /** SMS/text message preference */
  sms?: ContactMethodPreference4;
};
export type ContactSection = {
  communication_preferences: CommunicationsPreferencesResponse2;
  email?: string | null;
  mobile_phone?: string | null;
  preferred_language?: string;
};
export type DemographicsSection = {
  /** Date of birth (YYYY-MM-DD) */
  dob?: string | null;
  first_name?: string | null;
  gender?: string | null;
  /** Height in inches (in). Required by DoseSpot for minors. */
  height?: number | null;
  /** MRN / PRN */
  identifier?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  preferred_name?: string | null;
  pronouns?: string | null;
  race?: string | null;
  /** Sex for claims (Male/Female) */
  sex?: string | null;
  /** Weight in pounds (lb). Required by DoseSpot for minors. */
  weight?: number | null;
};
export type DiagnosisStatus7 = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo5 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** When the diagnosis was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the diagnosis was added to the chart. */
  date_added?: string | null;
  /** Diagnosis ID (UUID). */
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  /** Human-readable diagnosis name. */
  name: string;
  /** Suggestion-workflow status: 'accepted' (confirmed on the chart), 'suggested' (AI-proposed, pending provider review), or 'rejected'. Distinct from clinical active/inactive — see is_active. */
  status: DiagnosisStatus7;
};
export type EmergencyContactSection = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  relationship?: string | null;
};
export type EmploymentSection = {
  employment_status?: string | null;
  occupation?: string | null;
};
export type InsuranceSummary3 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type MedicationStatus3 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo3 = {
  /** When the medication was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the medication was prescribed. */
  date_prescribed?: string | null;
  /** Prescribed dose (e.g. '1 tablet'). */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  /** How often to take (e.g. 'twice daily'). */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  /** Medication ID (UUID). */
  medication_id: string;
  /** Human-readable medication name. */
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Suggestion-workflow status: 'accepted', 'suggested' (AI-proposed, pending review), 'rejected', or 'discontinued'. Distinct from clinical active/inactive — see is_active. */
  status: MedicationStatus3;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PaymentMethodResponse = {
  /** Card brand (visa, mastercard, amex, etc.) */
  card_brand?: string | null;
  /** Card expiration month */
  card_exp_month?: number | null;
  /** Card expiration year */
  card_exp_year?: number | null;
  /** Last 4 digits of the card */
  card_last4?: string | null;
  /** Stripe payment method ID */
  id: string;
  /** Whether this is the default payment method */
  is_default?: boolean;
  /** Payment method type */
  type?: string;
};
export type PatientPharmacyInfo3 = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this pharmacy has a DoseSpot PharmacyId. This is an identity link, not a sync health indicator; prefer sync_status for health. */
  is_dosespot_linked?: boolean;
  is_primary?: boolean;
  name: string;
  patient_pharmacy_id: string;
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  sync_failure_reason?: string | null;
  /** Current DoseSpot sync health. This takes precedence over is_dosespot_linked when sync_status is sync_failed. */
  sync_status?: "dosespot_linked" | "local_only" | "sync_failed";
  zip?: string | null;
};
export type PatientInfoResponse = {
  addresses: AddressesSection;
  allergies?: AllergyInfo3[];
  /** Resolved bill-with-JotPsych flag from org routing rules */
  bill_with_jotpsych_resolved?: boolean | null;
  /** Source: 'org_payer_rule' or 'org_default' */
  bill_with_jotpsych_source?: string | null;
  can_view_contact_information: boolean;
  consent: ConsentSection;
  contact: ContactSection;
  demographics: DemographicsSection;
  diagnoses?: DiagnosisInfo5[];
  /** Human-readable reason the last DoseSpot demographics push failed, or null when the patient is synced / not connected to DoseSpot. */
  dosespot_demographics_sync_failure_reason?: string | null;
  /** ISO timestamp of the last successful DoseSpot demographics push. */
  dosespot_demographics_synced_at?: string | null;
  emergency_contact?: EmergencyContactSection | null;
  employment: EmploymentSection;
  insurance_coverages?: InsuranceSummary3[];
  /** True when the patient is designated self-pay at the patient level (patients.is_self_pay, or a live self-pay coverage row during the GDN-3068 expand phase). */
  is_self_pay?: boolean;
  medications?: MedicationInfo3[];
  patient_id: string;
  payment_methods?: PaymentMethodResponse[];
  pharmacies?: PatientPharmacyInfo3[];
  primary_pharmacy?: PatientPharmacyInfo3 | null;
};
export type MedicationStatus4 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo4 = {
  /** When the medication was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the medication was prescribed. */
  date_prescribed?: string | null;
  /** Prescribed dose (e.g. '1 tablet'). */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  /** How often to take (e.g. 'twice daily'). */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  /** Medication ID (UUID). */
  medication_id: string;
  /** Human-readable medication name. */
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Suggestion-workflow status: 'accepted', 'suggested' (AI-proposed, pending review), 'rejected', or 'discontinued'. Distinct from clinical active/inactive — see is_active. */
  status: MedicationStatus4;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type MedicationListResponse = {
  medications: MedicationInfo4[];
};
export type MedicationStatus5 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo5 = {
  /** When the medication was accepted (confirmed) by a provider. */
  date_accepted?: string | null;
  /** When the medication was prescribed. */
  date_prescribed?: string | null;
  /** Prescribed dose (e.g. '1 tablet'). */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  /** How often to take (e.g. 'twice daily'). */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  /** Medication ID (UUID). */
  medication_id: string;
  /** Human-readable medication name. */
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Suggestion-workflow status: 'accepted', 'suggested' (AI-proposed, pending review), 'rejected', or 'discontinued'. Distinct from clinical active/inactive — see is_active. */
  status: MedicationStatus5;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type MedicationResponse = {
  medication: MedicationInfo5;
};
export type MedicationStatus6 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type AddMedicationRequest = {
  /** ISO 8601 date when medication was prescribed (defaults to now) */
  date_prescribed?: string | null;
  /** Dosage (e.g., 50mg) */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid, injection) */
  form?: string | null;
  /** Frequency (e.g., QD, BID, PRN) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Diagnosis or reason for prescribing (e.g., MDD, Anxiety) */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean | null;
  /** Medication name */
  name: string;
  /** Route of administration (e.g., oral, topical, sublingual) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Status of the medication (defaults to accepted) */
  status?: MedicationStatus6 | null;
  /** Strength per unit (e.g., 50mg, 100mg/5ml) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type MedicationStatus7 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type UpdateMedicationRequest = {
  /** ISO 8601 date when medication was prescribed */
  date_prescribed?: string | null;
  /** Dosage (e.g., 50mg) */
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid, injection) */
  form?: string | null;
  /** Frequency (e.g., QD, BID, PRN) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Diagnosis or reason for prescribing (e.g., MDD, Anxiety) */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean | null;
  /** Medication name */
  name?: string | null;
  /** Route of administration (e.g., oral, topical, sublingual) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  /** Status of the medication */
  status?: MedicationStatus7 | null;
  /** Strength per unit (e.g., 50mg, 100mg/5ml) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PatientPharmacyInfo4 = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this pharmacy has a DoseSpot PharmacyId. This is an identity link, not a sync health indicator; prefer sync_status for health. */
  is_dosespot_linked?: boolean;
  is_primary?: boolean;
  name: string;
  patient_pharmacy_id: string;
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  sync_failure_reason?: string | null;
  /** Current DoseSpot sync health. This takes precedence over is_dosespot_linked when sync_status is sync_failed. */
  sync_status?: "dosespot_linked" | "local_only" | "sync_failed";
  zip?: string | null;
};
export type PatientPharmacyListResponse = {
  pharmacies: PatientPharmacyInfo4[];
  primary_pharmacy?: PatientPharmacyInfo4 | null;
};
export type PatientPharmacyInfo5 = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this pharmacy has a DoseSpot PharmacyId. This is an identity link, not a sync health indicator; prefer sync_status for health. */
  is_dosespot_linked?: boolean;
  is_primary?: boolean;
  name: string;
  patient_pharmacy_id: string;
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  sync_failure_reason?: string | null;
  /** Current DoseSpot sync health. This takes precedence over is_dosespot_linked when sync_status is sync_failed. */
  sync_status?: "dosespot_linked" | "local_only" | "sync_failed";
  zip?: string | null;
};
export type PatientPharmacyResponse = {
  pharmacy: PatientPharmacyInfo5;
};
export type AddPatientPharmacyRequest = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  /** DoseSpot PharmacyId when this row is linked to DoseSpot; omitted for local-only pharmacies */
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this should become the preferred pharmacy */
  is_primary?: boolean;
  /** Pharmacy display name */
  name: string;
  /** Pharmacy type/specialty */
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdatePatientPharmacyRequest = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  /** DoseSpot PharmacyId to link or replace the local row */
  dosespot_pharmacy_id?: string | null;
  fax?: string | null;
  /** Whether this should be the preferred pharmacy */
  is_primary?: boolean | null;
  /** Pharmacy display name */
  name?: string | null;
  /** Pharmacy type/specialty */
  pharmacy_type?: string | null;
  phone?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type TreatmentPlanSnapshot = {
  created_at?: string | null;
  markdown_content?: string | null;
  must_be_updated_by?: string | null;
  type?: ("SOAP" | "DAP" | "BIRP" | "NARRATIVE") | null;
  updated_at?: string | null;
  updated_by?: string | null;
};
export type TreatmentPlan = {
  created_at?: string | null;
  history?: TreatmentPlanSnapshot[];
  markdown_content?: string | null;
  must_be_updated_by?: string | null;
  treatment_plan_id: string;
  type?: ("SOAP" | "DAP" | "BIRP" | "NARRATIVE") | null;
  updated_at?: string | null;
  updated_by?: string | null;
};
export type TreatmentPlanResponse = {
  treatment_plan: TreatmentPlan;
};
export type UpdateTreatmentPlanRequest = {
  /** Treatment plan markdown content */
  markdown_content: string;
};
export type CreateTreatmentPlanRequest = {
  /** Treatment plan markdown content */
  markdown_content: string;
};
export type SaveNoteAsTreatmentPlanRequest = {
  /** ID of the note to copy from */
  note_id: string;
};
export type MarkTreatmentPlanReviewedResponse = {
  must_be_updated_by: string;
};
export type TreatmentPlanReviewDateResponse = {
  must_be_updated_by: string;
};
export type SetTreatmentPlanReviewDateRequest = {
  /** ISO 8601 date (YYYY-MM-DD) */
  must_be_updated_by: string;
};
export type RollbackTreatmentPlanRequest = {
  /** History index to restore (0 = most recent previous; max 2) */
  index?: number;
};
